import { MimamoriConstants } from '@/config/constant';

export default {
  monitoringList: (state) => state.monitoringList,
  isFullMonitoringList: (state) => state.monitoringList.length === MimamoriConstants.maxAcount,
  isMonitoringLocked: (state) => state.monitoringStatus === MimamoriConstants.locked,
  monitoringInfo: (state) => state.monitoringInfo,
  monitoredList: (state) => state.monitoredList.list,
  monitoredCount: (state) => state.monitoredList.count,
  firstMonitoredRequest: (_, getters) => getters.monitoredCount ? getters.monitoredList[0]: {},
  monitoredNoticeList: (state) => state.monitoredNotice?.list,
  monitoredNoticeCount: (state) => state.monitoredNotice?.count,
  firstMonitoredNotice: (_, getters) => getters.monitoredNoticeCount ? getters.monitoredNoticeList[0]: {},
};
